import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditConstructionSiteForm } from '../EditConstructionSiteForm/EditConstructionSiteForm';
export type EditConstructionSiteDialogProps = PropsWithoutChildren<Omit<SingleTabEditDialogProps, 'tabTitle'>> & {
  constructionSite: ConstructionSite;
};
export const EditConstructionSiteDialog: FunctionComponent<EditConstructionSiteDialogProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let constructionSite;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      constructionSite,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = constructionSite;
    $[4] = remainingProps;
  } else {
    constructionSite = $[3];
    remainingProps = $[4];
  }
  const {
    t
  } = useTranslation();
  const handlePropertyChanged = useModifyEntityCallback(EntityName.ConstructionSite);
  let t1;
  if ($[5] !== t) {
    t1 = t("components.constructionSite.EditConstructionSiteDialog.title");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== constructionSite || $[8] !== handlePropertyChanged) {
    t2 = <EditConstructionSiteForm constructionSite={constructionSite} onPropertyChanged={handlePropertyChanged} data-testid="EditConstructionSiteDialog.EditConstructionSiteForm" />;
    $[7] = constructionSite;
    $[8] = handlePropertyChanged;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t2) {
    t3 = <SingleTabEditDialog {...remainingProps} tabTitle={t1}>{t2}</SingleTabEditDialog>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});